export { SocietyDetails as default } from './SocietyDetails';
